import React, { useMemo } from 'react';

import { getMoment } from '@libs/NwMoment';

import CustomSwitch from '@components/Gui/CustomSwitch';

import PrintStatementButton from '../PrintStatementButton';
import { useStatementContext } from '../StatementContext';

/**
 * PayableTools
 *
 * Tools bar for payable statements (expand toggle, print button)
 */
const PayableTools = ({ statementTypeFilter, handleOpenPrintDrawer, onUpdateExpand }) => {
    const { expand, filters } = useStatementContext();

    const rangeAsMoment = useMemo(() => {
        return [getMoment(filters.range[0]), getMoment(filters.range[1])];
    }, [filters.range]);

    return (
        <div className="statement-tools">
            <div className="margin-right-auto">
                <CustomSwitch size="small" value={expand} text="expand details" onChange={onUpdateExpand} />
            </div>
            <PrintStatementButton
                asButton
                dateFrom={rangeAsMoment[0]}
                dateTo={rangeAsMoment[1]}
                statementTypeFilter={statementTypeFilter}
                onOpenPrintDrawer={handleOpenPrintDrawer}
            />
        </div>
    );
};

export default PayableTools;
